module.exports = __webpack_public_path__ + "img/gongdan_mobile1.3f2b14f5.jpg";